import noShowSvg from '../assets/svg/Icons/32/no-show-gray.svg';
import sickCalloutSvg from '../assets/svg/Icons/32/sick-callout-gray.svg';

class ViewAbsenceCtrl {
  constructor(
    Restangular,
    Authentication,
    ConfirmService,
    EventCollection,
    LeaveService,
    ShiftUtils,
    UserUtils,
    uppercaseFirstFilter,
    sdk
  ) {
    'ngInject';

    const { NO_SHOW_TYPE, SICK_CALLOUT_TYPE } = sdk('constants');
    this.NO_SHOW_TYPE = NO_SHOW_TYPE;
    this.SICK_CALLOUT_TYPE = SICK_CALLOUT_TYPE;
    this.eventSummary = 0;

    this.ABSENCES_DICT = {
      [NO_SHOW_TYPE]: 'no show',
      [SICK_CALLOUT_TYPE]: 'sick callout',
    };

    Object.assign(this, {
      Restangular,
      Authentication,
      ConfirmService,
      EventCollection,
      LeaveService,
      ShiftUtils,
      UserUtils,
      uppercaseFirstFilter,
      sdk,
    });
  }

  $onInit() {
    this.event.sameDay = this.event.dtstart.toDateString() === this.event.dtend.toDateString();
    this.setSummary();
    this.getHistory();
  }

  get absenceName() {
    return this.ABSENCES_DICT[this.event.type];
  }

  async setSummary() {
    if (this.event.type === this.NO_SHOW_TYPE) {
      const summary = await this.LeaveService.getNoShowSummary(this.event.user.id);
      this.eventSummary = summary.no_shows || 0;
    }

    if (this.event.type === this.SICK_CALLOUT_TYPE) {
      const summary = await this.LeaveService.getSickCalloutSummary(this.event.user.id);
      this.eventSummary = summary.sick_callouts || 0;
    }
  }

  shouldShowSummary() {
    return (
      this.event.summary?.length && (this.Authentication.user.isManager || this.event.user.isMe)
    );
  }

  modalTitle() {
    return `Shift • ${this.absenceName[0].toUpperCase()}${this.absenceName.slice(1)}`;
  }

  modalIcon() {
    return this.event.type === this.NO_SHOW_TYPE ? noShowSvg : sickCalloutSvg;
  }

  deleteAbsence() {
    const deleteConfirmMsg = `Are you sure you want to delete this ${this.absenceName}?`;
    const deleteAction =
      this.event.type === this.NO_SHOW_TYPE
        ? this.EventCollection.deleteNoShow
        : this.EventCollection.deleteSickCallout;
    this.ConfirmService.ask(deleteConfirmMsg, async () => {
      await deleteAction(this.event.id);
      this.modal.close();
    }).ignoreCancel();
  }

  canDeleteAbsence() {
    const canActOnLocation = this.Authentication.user.canActOnLocation(this.event.location);
    return !this.isNew && this.Authentication.user.isManager && canActOnLocation;
  }

  canEditGroup(group) {
    return this.UserUtils.canEditGroup(group);
  }

  async getHistory() {
    this.historyMode = true;
    this.history = null;
    try {
      const logs = await this.EventCollection.getLogs(this.event.id);
      this.history = logs;
      if (logs.length) {
        this.eventInfo = logs[0];
      }
    } catch (e) {
      this.history = [];
      throw e;
    }
  }
}

export default ViewAbsenceCtrl;
